module.exports = __webpack_public_path__ + "static/media/sub_sto_lab.dccca7e4.png";